import { CSSObject } from '@emotion/css';

export const defaultLinkStyle: CSSObject = {
  /**
   * Colour set by defining these css variables
   *
   * --link-color
   * --link-color-hover
   * --link-color-active
   */
  color: 'var(--link-color)',
  cursor: 'pointer',
  fontWeight: 'inherit',
  textDecoration: 'none',

  '&:hover': {
    color: 'var(--link-color-hover)',
    textDecoration: 'underline',
  },

  '&:focus': {
    color: 'var(--link-color-hover)',
    textDecoration: 'underline',
  },

  '&:active': {
    color: 'var(--link-color-active)',
    textDecoration: 'underline',
  },

  '--link-color': 'var(--color-link)',
  '--link-color-hover': 'var(--color-hover)',
  '--link-color-active': 'var(--color-active)',
};

export const inlineTextLinkStyle: CSSObject = {
  ...defaultLinkStyle,
  textDecoration: 'underline',

  '&.bg-dark': {
    '--link-color': 'var(--color-white)',
    '--link-color-hover': 'var(--color-white)',
    '--link-color-active': 'var(--color-border)',
  },
};
